(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionDeleteController',Qsched_directionDeleteController);

    Qsched_directionDeleteController.$inject = ['$uibModalInstance', 'entity', 'Qsched_direction'];

    function Qsched_directionDeleteController($uibModalInstance, entity, Qsched_direction) {
        var vm = this;

        vm.qsched_direction = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Qsched_direction.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
